/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { OffsetPaginationDto } from '../models/offset-pagination-dto';
import { ProductDto } from '../models/product-dto';
import { userProductControllerFindById } from '../fn/user-product/user-product-controller-find-by-id';
import { UserProductControllerFindById$Params } from '../fn/user-product/user-product-controller-find-by-id';
import { userProductControllerSearch } from '../fn/user-product/user-product-controller-search';
import { UserProductControllerSearch$Params } from '../fn/user-product/user-product-controller-search';

@Injectable({ providedIn: 'root' })
export class UserProductService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `userProductControllerSearch()` */
  static readonly UserProductControllerSearchPath = '/api/user-product';

  /**
   * Search products.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userProductControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  userProductControllerSearch$Response(params: UserProductControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return userProductControllerSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * Search products.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userProductControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userProductControllerSearch(params: UserProductControllerSearch$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.userProductControllerSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `userProductControllerFindById()` */
  static readonly UserProductControllerFindByIdPath = '/api/user-product/{id}';

  /**
   * Get product by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userProductControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  userProductControllerFindById$Response(params: UserProductControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductDto>> {
    return userProductControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * Get product by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userProductControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userProductControllerFindById(params: UserProductControllerFindById$Params, context?: HttpContext): Observable<ProductDto> {
    return this.userProductControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProductDto>): ProductDto => r.body)
    );
  }

}
